<template>
  <div class="lessee-management">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="page-content">
      <div style="flex: 1;">
        <div class="search-line">
          <div class="btn-box">
            <button-add :value="addBtnValue" :pathName="addLesseeRouterName" v-if="permissionCodes.indexOf('001005001') !== -1" />
            <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('001005002') !== -1"/>
<!--            <button-upload :cathUrl="uploadUrl" v-if="permissionCodes.indexOf('001005004') !== -1" :onSuccess="uploadSuccess" @getpage="getPage" value="导入"/>-->
<!--            <button-export :href="exportUrl" :beforeDownload="beforeDownload" v-if="permissionCodes.indexOf('001005005') !== -1" download="download.xls" value="导出"/>-->
          </div>
          <input-search placeholder="姓名/手机号" @search="search" style="width: 280px;"/>
        </div>

        <table-main :tableHead="tableHead" :tableData="tableData" deleteTipInfo="是否确认删除此承租人？" @deleteLine="deleteLine" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @allocateListings="showAllocateListingsVisible" @modifyListings="showModifyAllocateListingsVisible" @deleteListings="delLeaseRoomBindByCodes" />
      </div>
    </div>

    <el-dialog title="分配房源" :visible.sync="allocateListingsVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-select v-model="allocateListingsRoomCode" filterable remote reserve-keyword placeholder="请输入关键词查询" size="mini" style="width: 280px" :remote-method="roomInfoMethod" @change="changeAllocateListingsRoomCode">
            <el-option v-for="item in roomList" :key="item.code" :label="item._label" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line" v-if="bedsListInRoom.length > 0">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">床位：</span>
          </div>
          <el-select v-model="bedChooseCode" multiple placeholder="请选择床位" size="mini" style="width: 280px">
            <el-option v-for="item in bedsListInRoom" :key="item.code" :label="item.bedsNumber" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租金：</span>
          </div>
          <el-input v-model="rentPrice" size="small" style="width: 280px" >
            <el-select v-model="rentPriceUnit" slot="append" style="width: 120px;">
              <el-option v-for="item in rentPriceUnitList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁起始时间：</span>
          </div>
          <el-date-picker v-model="leaseStartTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁起始时间" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁结束时间：</span>
          </div>
          <el-date-picker v-model="leaseStopTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁结束时间" size="small" style="width: 280px" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="allocateListingsVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="allotPersonLeaseRoom" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改房源" :visible.sync="modifyAllocateListingsVisible" width="800px">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间号：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.roomNumber" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line" v-if="modifyAddAllocateListings.bedsNumber">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">床位：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.bedsNumber" size="small" style="width: 280px" disabled />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租金：</span>
          </div>
          <el-input v-model="modifyAddAllocateListings.price" size="small" style="width: 280px" >
            <el-select v-model="modifyAddAllocateListings.priceUnit" slot="append" style="width: 120px;">
              <el-option v-for="item in modifyRentPriceUnitList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁起始时间：</span>
          </div>
          <el-date-picker v-model="modifyAddAllocateListings.leaseStartTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁起始时间" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">租赁结束时间：</span>
          </div>
          <el-date-picker v-model="modifyAddAllocateListings.leaseStopTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择租赁结束时间" size="small" style="width: 280px" />
        </div>
      </form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyAllocateListingsVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateLeaseRoomBind" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import ButtonAdd from '../../../components/Button/ButtonAdd'
import ButtonDelete from '../../../components/Button/ButtonDelete'
import ButtonExport from '../../../components/common/buttons/button-export'
import ButtonUpload from '../../../components/common/buttons/button-upload'
import InputSearch from '../../../components/Input/InputSearch'
import InputSelect from '../../../components/Input/InputSelect'
import TableMain from '../../../components/Table/TableMain'
import TheTree from '../../../components/Tree/the-tree'
import STree from '../../../components/common/s-tree'
import {treeApi} from '../../api/TreeApi'
import {api} from '../../api/LeaseManage'
import {errorHandler} from '../../../utils/errorHandler'
import {nAlert, nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from "../../../components/Button/ButtonCancel";
import {deepCloneFunction} from "../../../tool/tools";

export default {
  components: {
    ButtonConfirm,
    ButtonConfirmNext,
    STree,
    TheTree,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    ButtonCancel,
    Breadcrumb},
  name: 'lessee-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '个人承租'
      }],
      addBtnValue: '添加承租人',
      addLesseeRouterName: 'lessee-add',
      exportUrl: '',
      uploadUrl: '',
      cardTypeList: [{
        key: '',
        label: '全部'
      }],
      tableHead: [
        {prop: 'leaseRoomBindList', label: '', hasExpand: true, tableHead: [{prop: 'leaseRoomNumberLabel', label: '房间号'}, {prop: 'roomArea', label: '房间面积(m²)'}, {prop: 'roomType', label: '房间类型'}, {prop: 'bedsNumber', label: '床位编号'}, {prop: 'price', label: '租金(元)'}, {prop: 'leaseStartTime', label: '租赁起始时间'}, {prop: 'leaseStopTime', label: '租赁结束时间'},]},
        {prop: 'personName', label: '姓名'},
        {prop: 'sexText', label: '性别'},
        {prop: 'phone', label: '手机号'},
        {prop: 'identityNumber', label: '身份证号'},
        {prop: 'rentTypeText', label: '申请房型'},
        {prop: 'stayStartTime', label: '预入住日期'},
        {prop: 'leaseTimeLimit', label: '预租期限'},
        {prop: 'statusText', label: '状态'},
        {prop: 'remarks', label: '备注'}
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      searchKey: '',

      hasPhoto: '',
      isAuthorize: '',
      isSubscribe: '',
      selectionArr: [],

      approveDialog: false,
      unApproveReason: '',


      yqAppCode: '',
      accountName: '',

      allocateListingsVisible: false,
      dialogInputWidth: '120px',
      addAllocateListings: {
        code: '',
        rooms: []
      },
      leaseStartTime: '',
      leaseStopTime: '',
      allocateListingsRoomCode: '',
      roomList: [],
      bedChooseCode: '',
      bedsListInRoom: [],
      rentPrice: '',
      rentPriceUnit: '2',
      rentPriceUnitList: [
        {code: '1', name: '元 / 间 / 月'},
        {code: '2', name: '元 / 间 / 天'},
      ],

      modifyAllocateListingsVisible: false,
      modifyDialogInputWidth: '120px',
      modifyAddAllocateListings: {},
      modifyRentPriceUnitList: [
        {code: '1', name: '元 / 间 / 月'},
        {code: '2', name: '元 / 间 / 天'},
      ],

      rentType: ''
    }
  },
  created () {
    this.yqAppCode = bus.global.yqCode
    this.accountName = bus.global.accountName
    this.permissionCodes = bus.global.permissionCodes
    this.uploadUrl = api.importPerson
  },
  activated() {
    this.getPage()
  },
  methods: {
    // 查询房源
    roomInfoMethod (query) {
      this.getRoomInfoList(query)
    },
    // 获取房源列表
    getRoomInfoList (searchKey) {
      this.$axios.post(api.getRoomInfoList, {
        rentType: this.rentType,
        searchKey: searchKey || ''
      })
        .then(res => {
          let data = res.data.data || []
          data.map(v => {
            v._label = `${v.buildingName}/${v.floorName}层/${v.roomNumber}/${v.roomType || ''}`
          })
          this.roomList = data
        })
        .catch(errorHandler('获取房源列表失败'))
    },

    changeAllocateListingsRoomCode (value) {
      this.roomList.map(v => {
        if (v.code === value) {
          let room = [], bedsListInRoom = []
          room = [
            {
              code: v.code,
              roomNumber: v.roomNumber,
              beds: [],
              leaseStartTime: '',
              leaseStopTime: '',
              price: '',
              priceUnit: ''
            }
          ]
          bedsListInRoom = v.beds || []
          this.addAllocateListings.rooms = room
          this.bedsListInRoom = bedsListInRoom
        }
      })
    },

    beforeDownload () {
      this.exportUrl = `${api.exportPerson}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.searchKey}&hasPhoto=${this.hasPhoto}&isAuthorize=${this.isAuthorize}&isSubscribe=${this.isSubscribe}`
    },
    uploadSuccess (data) {
      const e = errorHandler('导入失败')(data)
      if (!(e instanceof Error)) {
        nSuccess('导入成功')
        this.getPage()
      }
    },
    getPage () {
      this.$axios.post(api.getPersonLeasePage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKey: this.searchKey
      })
        .then(res => {
          let data = res.data.data.list
          data.map(v => {
            let leaseRoomBindList = v.leaseRoomBindList || []
            leaseRoomBindList.map(leaseRoom => {
              leaseRoom.leaseRoomNumberLabel = `${leaseRoom.buildingName}/${leaseRoom.floorName}层/${leaseRoom.roomNumber}`
            })
            v.sexText = v.sex === '0' ? '男' : (v.sex === '1' ? '女' : '')
            v.rentTypeText = v.rentType === 1 ? '床位' : '整租'
            if (v.status === 0) {
              v.statusText = '申请中'
            } else if (v.status === 1) {
              v.statusText = '已通过'
            } else if (v.status === 2) {
              v.statusText = '已驳回'
            } else if (v.status === 3) {
              v.statusText = '已撤回'
            } else if (v.status === 4) {
              v.statusText = '已作废'
            }
          })
          this.total = res.data.data.total
          this.tableData = data
        })
        .catch(errorHandler('获取数据失败'))
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    searchCardType (v) {
      this.pageNum = 1
      this.cardTypeCode = v.value
      this.getPage()
    },
    searchIsAuthorize (v) {
      this.pageNum = 1
      this.isAuthorize = v.value
      this.getPage()
    },
    searchIsSubscribe (v) {
      this.pageNum = 1
      this.isSubscribe = v.value
      this.getPage()
    },
    searchHasPhoto (v) {
      this.pageNum = 1
      this.hasPhoto = v.value
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    toCurrentPage (code) {
      this.$router.push({
        path: `/lessee_current/${code}`
      })
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的人员')
        return false
      } else {
        this.$confirm('确定删除已选中的人员？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    deleteLine (code) {
      this.$axios.post(api.delPersonLeaseByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('删除人员信息失败'))
    },

    showAllocateListingsVisible (data) {
      this.addAllocateListings.rooms = []
      this.leaseStartTime = ''
      this.leaseStopTime = ''
      this.allocateListingsRoomCode = ''
      this.bedChooseCode = ''
      this.bedsListInRoom = []
      this.rentPrice = ''
      this.rentType = data.rentType
      if (data.rentType === 0) {
        this.rentPriceUnit = '1'
        this.rentPriceUnitList = [
          {code: '1', name: '元 / 间 / 月'},
          {code: '2', name: '元 / 间 / 天'},
        ]
      } else {
        this.rentPriceUnit = '3'
        this.rentPriceUnitList = [
          {code: '3', name: '元 / 床 / 月'},
          {code: '4', name: '元 / 床 / 天'},
        ]
      }
      this.allocateListingsRoomCode = ''
      this.addAllocateListings.code = data.code
      this.getRoomInfoList()
      this.allocateListingsVisible = true
    },

    allotPersonLeaseRoom () {
      if (!this.allocateListingsRoomCode) {
        nError('请选择房间')
        return false
      }
      if (!this.bedChooseCode && this.bedsListInRoom.length > 0) {
        nError('请选择床位')
        return false
      }
      if (!this.leaseStopTime) {
        nError('请选择租赁结束时间')
        return false
      }
      if (!this.leaseStartTime) {
        nError('请选择租赁起始时间')
        return false
      }
      if (!this.leaseStopTime) {
        nError('请选择租赁结束时间')
        return false
      }
      let beds = []
      if (this.bedChooseCode && this.bedsListInRoom.length > 0) {
        this.bedsListInRoom.map(bed => {
          if (this.bedChooseCode.indexOf(bed.code) !== -1) {
            beds.push({code: bed.code, bedsNumber: bed.bedsNumber})
          }
        })
      }
      this.addAllocateListings.rooms[0].beds = beds
      this.addAllocateListings.rooms.map(room => {
        room.leaseStartTime = this.leaseStartTime
        room.leaseStopTime = this.leaseStopTime
        room.price = this.rentPrice
        room.priceUnit = this.rentPriceUnit
        room.beds.map(bed => {
          bed.leaseStartTime = this.leaseStartTime
          bed.leaseStopTime = this.leaseStopTime
          bed.price = this.rentPrice
          bed.priceUnit = this.rentPriceUnit
        })
      })
      this.$axios.post(api.allotPersonLeaseRoom, this.addAllocateListings)
        .then(res => {
          nSuccess('操作成功')
          this.allocateListingsVisible = false
          this.getPage()
        })
        .catch(errorHandler('操作失败'))
    },

    // 展示修改信息
    showModifyAllocateListingsVisible (data) {
      this.rentType = data.rentType
      this.modifyAddAllocateListings = deepCloneFunction(data)
      if (data.rentType === 0) {
        this.rentPriceUnit = '1'
        this.rentPriceUnitList = [
          {code: '1', name: '元 / 间 / 月'},
          {code: '2', name: '元 / 间 / 天'},
        ]
      } else {
        this.rentPriceUnit = '3'
        this.rentPriceUnitList = [
          {code: '3', name: '元 / 床 / 月'},
          {code: '4', name: '元 / 床 / 天'},
        ]
      }
      this.getRoomInfoList()
      this.modifyAllocateListingsVisible = true
    },

    // 修改房源信息
    updateLeaseRoomBind () {
      this.$axios.post(api.updateLeaseRoomBind, this.modifyAddAllocateListings)
        .then(res => {
          this.modifyAllocateListingsVisible = false
          nSuccess('修改成功')
          this.getPage()
        })
        .catch(errorHandler('修改失败'))
    },

    // 房源解绑
    delLeaseRoomBindByCodes (data) {
      console.log(data)
      this.$confirm('是否确认解绑此房源？', "温馨提示", {
        type: "warning"
      })
        .then(() => {
          this.$axios.post(api.delLeaseRoomBindByCodes, [data.code])
            .then(res => {
              nSuccess('解绑成功')
              this.getPage()
            })
            .catch(errorHandler('解绑失败'))
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
  },
  watch: {}
}
</script>

<style scoped>

.page-content{
  display: flex;
  justify-content: space-between;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
  .person-management {
    .el-tree-node__content {
      height: 28px;
    }
    .right-slide-enter,
    .right-slide-leave-active {
      transform: translateX(100%);
    }

    .right-slide-leave-active,
    .right-slide-enter-active {
      transition: all 0.3s;
    }
    .window-left-box {
      position: fixed;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60%;
      z-index: 10;
    }
    .window-left-box .move-enter-active, .window-left-box .move-leave-active {
      transition: all 2s linear;
      transform: translate3d(0, 0, 0);
    }
    .window-left-box .move-enter, .window-left-box .move-leave {
      transform: translate3d(100%, 0, 0);
    }
    .window-left-main {
      width: 100%;
      height: 100%;
      z-index: 30;
      background: #FFFFFF;
      padding: 5px 10px;
      overflow: auto;
    }

    .mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      z-index: -1;
      background-color: #000000;
      transition: opacity .5s ease;
    }


    form {
      width: 450px;
      margin: 0 auto;
      text-align: left;
    }
    .form-line {
      margin: 25px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .line-text{
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 100px;
      display: flex;
      justify-content: space-between;
    }
    .line-info {
      width: 220px;
    }
    .form-btn-box {
      width: 530px;
      padding: 0 124px;
      margin: 40px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .person-management-drawer {
      .el-icon-back {
        margin: 20px 20px 10px;
        display: block;
        border: 0;
        font-size: 20px;
        background-color: #ffffff;
        cursor: pointer;
      }
      .el-icon-back:hover {
        color: #00a0e6;
      }
      .all-table-class .el-table td {
        padding: 10px 0;
      }
      form {
        position: relative;
        .drawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
        }
        .noDrawerPersonImg {
          position: absolute;
          right: 0;
          top: 0;
          width: 120px;
          height: 150px;
          line-height: 160px;
          border: 1px dashed #dcdfe6;
          text-align: center;
          color: #999999;
        }
      }
    }
    .drawerBtnBox {
       width: 360px;
       padding-right: 60px;
       margin: 0 auto;
      .btn-confirm {
        border: 0;
        color: #FFF;
        padding: 8px 16px;
        background-color: #00a0e6;
        border-radius: 4px;
        margin-right: 60px;
      }
      .btn-confirm:hover {
        color: #FFF;
        background-color: #06b3ff;
      }
      .reject-button {
        border: 0;
        background-color: #f25721;
        color: #FFFFFF;
        border-radius: 4px;
      }
      .reject-button:hover {
        background-color: #F96E3D;
      }
    }

    .approveDialogBox {
      text-align: left;
      .el-dialog {
        width: 800px;
      }
      .approveMainBox {
        text-align: center;
      }
      .approve_title {
        width: 120px;
      }
      .approveFlexBox {
        width: 500px;
        margin: 0 auto 20px;
        display: flex;
        justify-content: flex-start;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/LesseeManage/LesseeManage.vue